import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}>
    <g transform="translate(4 4)">
      <path d="M9 0a9 9 0 110 18A9 9 0 019 0zm0 2a7 7 0 100 14A7 7 0 009 2zm1 3v3h3v2h-3v3H8v-3H5V8h3V5h2z" />
    </g>
  </svg>
);

const IconWin = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconWin;
